import React from "react";
import { Box, useTheme } from "@mui/material";
import {
  ButtonType,
  CustomTextField,
  useLayoutConstants,
} from "@BehpardazBarin/frontend_components";
import { customCaptchaProps, inputBoxPositions } from "../../constants/Style";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useLocation } from "react-router";
import { PrimaryCustomButton } from "../CustomButtons/PrimaryCustomButton";

interface CaptchaProps {
  captchaImage: string; // base64 string
  value: string | number;
  onInputChange: (input: string | number) => void;
  onResetCaptcha: () => void;
}

const Captcha: React.FC<CaptchaProps> = ({
  captchaImage,
  value,
  onInputChange,
  onResetCaptcha,
}) => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { isMobile } = useLayoutConstants(pathname);

  return (
    <Box display="flex" alignItems="center">
      <CustomTextField
        label="کد امنیتی"
        value={value}
        placeholder={"کد امنیتی روبرو را وارد کنید..."}
        onChange={onInputChange}
        customStyle={{
          ...inputBoxPositions,
          width: isMobile ? "195px" : "250px",
          marginLeft: isMobile ? undefined : "0",
        }}
        {...customCaptchaProps(theme)}
      />

      <PrimaryCustomButton
        value={""}
        onClickHandler={onResetCaptcha}
        buttonType={ButtonType.iconButton}
        children={<RefreshIcon fontSize="medium" />}
        customButtonStyle={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "48px",
          height: "48px",
          borderColor: theme.customColors.neutral[80],
          borderRadius: "8px",
          marginTop: isMobile ? "30px" : "25px",
          marginRight: isMobile ? "2px" : "10px",
          marginLeft: isMobile ? "-3px" : "-5px",
        }}
      />

      <Box
        component="img"
        src={`${captchaImage}`}
        alt="CAPTCHA"
        sx={{
          width: isMobile ? "100px" : "150px",
          height: "48px",
          border: `1px solid ${theme.customColors.neutral[80]}`,
          borderRadius: "8px",
          mt: isMobile ? 2 : 1,
        }}
      />
    </Box>
  );
};

export default Captcha;
